import { RichText } from "@wordpress/block-editor";
import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import { cn } from "../../utils";

const Save: React.ComponentType<BlockSaveProps<any>> = (props) => {
	const {
		attributes: { cssID, clientId, className, text, typography },
	} = props;

	if (RichText.isEmpty(text)) {
		return null;
	}

	return (
		<p
			id={cssID ?? undefined}
			className={cn(
				`mzb-paragraph mzb-paragraph-${clientId}`,
				typography?._className,
				className
			)}
		>
			{<RichText.Content value={text} />}
		</p>
	);
};

export default Save;
